<template>
  <div class="modal-pdv modal-small show" id="modalPagamento" tabindex="0" v-if="open">
    <div class="modal-pdv-content p-0" :class="{gestor}">
      <div class="container-fluid px-0" v-if="pagEdit">
        <div class="p-3 pb-0 height-100">
          <h6 class="mb-3 font-weight-bold text-center">{{ !pagEdit.transacao ? 'Editar' : ''}} Pagamento</h6>
          <hr>
          <div class="row">
            <div class="col-md-6 mb-2" v-if="formas_pagamento">
              <label class="mb-0">Pagamento</label>
              <select class="form-control" v-model="pagEdit.id_pagamento" :disabled="pagEdit.id_voucher || pagEdit.online || pagEdit.transacao">
                <option :value="p.id_pagamento" v-for="p in formas_pagamento">{{ p.nome_pagamento }}</option>
              </select>
            </div>
            <div class="col-md-6 mb-2">
              <label class="mb-0">Valor</label>
              <div class="form-control" style="background-color: #EAECF4">{{pagEdit.valor | valor}}</div>
            </div>
          </div>
          <div class="mb-2" v-if="['2','44'].includes(pagEdit.id_pagamento)">
            <label class="mb-0">Data vencimento</label>
            <input type="date" class="form-control" v-model="pagEdit.data_vencimento">
          </div>
          <div class="mb-2">
            <label class="mb-0">Observação</label>
            <textarea class="form-control" rows="3" style="resize: none" maxlength="128" v-model="pagEdit.observacao" placeholder="Observações sobre o pagamento" :disabled="pagEdit.id_pagamento === '21'"></textarea>
          </div>
          <div class="mt-1" v-if="pagEdit.transacao">
            <b>Transação:</b> {{pagEdit.transacao}}
          </div>
        </div>
      </div>
      <div class="modal-content-footer bg-light border-top p-2 d-flex justify-content-between">
        <button class="btn btn-dark p-3" @click="closeModal()">
          <i class="fa fa-chevron-left mr-2"></i>
          <span>Voltar</span>
        </button>
        <button class="btn btn-success p-3" @click="salvarPagamento()" v-if="!pagEdit.transacao">
          <i class="fa fa-check mr-2"></i>
          <span>Salvar</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditarPagamento",
  props: ['formas_pagamento', 'gestor'],

  data() {
    return {
      open: false,
      pagEdit: null
    }
  },

  methods: {
    openEditar(dados) {
      this.pagEdit = dados;
      this.open = true;
    },

    closeModal() {
      this.open = false;
    },

    salvarPagamento() {
      this.$emit('salvar', this.pagEdit);
      this.open = false;
    }
  }
}
</script>

<style scoped>
  .modal-pdv-content.gestor {
    margin-top: 72px!important;
  }
</style>